__turbopack_context__.v({
  "content": "P9-VFa_content",
  "contentAppBody1": "P9-VFa_contentAppBody1",
  "contentBody1": "P9-VFa_contentBody1",
  "contentBody2": "P9-VFa_contentBody2",
});
